import { h, Host } from "@stencil/core";
import { MessageTypes } from "./message-types";
export class MessageBox {
    constructor() {
        this.type = MessageTypes.info;
        this.intro = "";
        this.headline = "";
        this.icon = null;
        this.iconSize = "60px";
        this.noCloseButton = false;
    }
    baseClass = "ux-message-box";
    messageBoxElement;
    /** Emitted before the actual redirect takes place, includes the URL, can be cancelled  */
    close;
    /** close message box on click */
    closeMessageBox = () => {
        const evt = this.close.emit(this.messageBoxElement);
        if (!evt.defaultPrevented) {
            this.messageBoxElement.remove();
        }
    };
    getIcon = () => {
        if (this.icon === null) {
            switch (this.type) {
                case MessageTypes.success:
                    return "checkmark-thin";
                case MessageTypes.info:
                    return "info-rounded";
                case MessageTypes.warning:
                    return "warning-triangle-simple";
                case MessageTypes.error:
                    return "close-thin";
            }
        }
        return this.icon;
    };
    render() {
        const { baseClass, type, intro, headline, iconSize, noCloseButton } = this;
        const icon = this.getIcon();
        return (h(Host, { key: 'd8a38fd8d72c70b80926d6cd2c34b9c9605f7db6', class: `${baseClass} ${baseClass}--${type}` }, h("div", { key: '6cbf8429e28081096fbcd3bb4d72b56c5fa25719', class: `${baseClass}__container` }, !noCloseButton && (h("div", { key: '1bde54099a4ed5456b8460204278ab7fc8da5ea1', class: `${baseClass}__close`, onClick: this.closeMessageBox }, h("ux-icon", { key: '3960f852c042582248a325fc2ccf57577f1d9955', name: "cross", weight: "normal" }))), icon !== "" && (h("div", { key: 'eb13bb793084a84c5dfed4cae85cbdb25a0e51c9', class: `${baseClass}__icon` }, h("ux-icon", { key: '81d16e8b653012d8946e0ef9620293097c357293', name: `${icon}`, style: { fontSize: iconSize } }))), h("div", { key: 'c3ee24bc6a82cd352527f14a54d180b175fc7879', class: `${baseClass}__text` }, intro !== "" && h("span", { key: 'e47be30da1b87c3e680d96df02ce1594de3a015c', class: `${baseClass}__text-intro ux-text-status` }, intro), headline !== "" && (h("span", { key: 'b7d87596ac4d310eb059fe7be55476ebde26f064', class: `${baseClass}__text-headline ux-text-title ux-text-title--bold` }, headline)), h("span", { key: 'b062943180cb0f3f2d9ebfa4a83d823163f5ba15', class: `${baseClass}__text-text ux-text-normal` }, h("slot", { key: '319a391de7af5d35015d32ce4e271cf86a15c5a1' }))))));
    }
    static get is() { return "ux-message-box"; }
    static get originalStyleUrls() {
        return {
            "$": ["message-box.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["message-box.css"]
        };
    }
    static get properties() {
        return {
            "type": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "MessageType",
                    "resolved": "MessageTypes.error | MessageTypes.info | MessageTypes.success | MessageTypes.warning",
                    "references": {
                        "MessageType": {
                            "location": "import",
                            "path": "./message-types",
                            "id": "src/components/message-box/message-types.ts::MessageType"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "message box type. Possible values are `error`,`info`,`warning` and `success`"
                },
                "attribute": "type",
                "reflect": false,
                "defaultValue": "MessageTypes.info"
            },
            "intro": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "intro text that is displayed above the headline"
                },
                "attribute": "intro",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "headline": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "headline text"
                },
                "attribute": "headline",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "icon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "icon - set empty string to omit the icon"
                },
                "attribute": "icon",
                "reflect": false,
                "defaultValue": "null"
            },
            "iconSize": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "icon size with unit"
                },
                "attribute": "icon-size",
                "reflect": false,
                "defaultValue": "\"60px\""
            },
            "noCloseButton": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "do not show the close button"
                },
                "attribute": "no-close-button",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get events() {
        return [{
                "method": "close",
                "name": "uxMessageClose",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted before the actual redirect takes place, includes the URL, can be cancelled"
                },
                "complexType": {
                    "original": "HTMLUxMessageBoxElement",
                    "resolved": "HTMLUxMessageBoxElement",
                    "references": {
                        "HTMLUxMessageBoxElement": {
                            "location": "global",
                            "id": "global::HTMLUxMessageBoxElement"
                        }
                    }
                }
            }];
    }
    static get elementRef() { return "messageBoxElement"; }
}
//# sourceMappingURL=message-box.js.map
